exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".global-filter-button {\n  display: flex !important;\n  justify-content: space-between;\n  align-items: center;\n  font-family: \"Source Sans Pro\", sans-serif;\n  height: 60px !important;\n  width: 225px;\n  border-color: #ccc !important; }\n  .global-filter-button:hover .left-section {\n    color: rgba(0, 0, 0, 0.65); }\n  .global-filter-button .left-section {\n    display: flex;\n    flex-direction: column;\n    text-align: justify; }\n    .global-filter-button .left-section .global-filter-button-title {\n      font-weight: bold; }\n  .global-filter-button .right-section .menu-divider {\n    margin-right: 10px;\n    width: 1px;\n    background-color: #ccc;\n    height: 42px;\n    float: right; }\n  .global-filter-button .global-filter-text {\n    white-space: pre; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./client/modules/Analytics/components/common/GlobalFilterButton/style.scss
// module id = 984
// module chunks = 0